import { render, staticRenderFns } from "./TabelaCapitulos.vue?vue&type=template&id=52084f78"
import script from "./TabelaCapitulos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabelaCapitulos.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports